var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-admin-estates-item-modes"},_vm._l((_vm.modes),function(item,i){return _c('div',{key:i,staticClass:"page-admin-estates-item-modes__item",class:{
            _active: item.code === _vm.activeMode,
            _invalid: item.isInvalid,
        },domProps:{"textContent":_vm._s(item.title)},on:{"click":function($event){return _vm.$emit('update', item.code)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }